<template>
  <v-container grid-list-xl v-if="oneDeposit">
    <v-text-field readonly label="Cliente" :value="oneDeposit.data.attributes.client_name"></v-text-field>
    <v-row justify="space-around">
      <v-col cols='5'>
        <v-text-field readonly label="Pago em" :value="oneDeposit.data.attributes.payed"></v-text-field>
      </v-col>
      <v-col cols='5' v-if="oneDeposit.data.attributes.confirmed">
        <v-text-field readonly label="Confirmado em" :value="oneDeposit.data.attributes.confirmed"></v-text-field>
      </v-col>
      <v-col cols='5' v-if="oneDeposit.data.attributes.confirmed">
        <v-text-field readonly label="Confirmado por" :value="oneDeposit.data.attributes.confirmed_by"></v-text-field>
      </v-col>
      <v-col cols='5'>
        <!-- <v-text-field readonly label="Depositado em" :value="(new Date(oneDeposit.data.attributes.deposit_date)).toDateString('pt-BR')"></v-text-field> -->
        <v-text-field readonly label="Depositado em" :value="oneDeposit.data.attributes.deposit_date_aux"></v-text-field>
      </v-col>
      <v-col cols='5'>
        <v-text-field readonly label="Banco" :value="oneDeposit.data.attributes.deposit_bank"></v-text-field>
      </v-col>
      <v-col cols='5'>
        <v-text-field readonly label="Empresa" :value="oneDeposit.data.attributes.deposit_company"></v-text-field>
      </v-col>

      <v-col cols='12' v-if="oneDeposit.data.attributes.comment">
        <v-textarea hide-details rows='2' readonly label="Comentários" :value="oneDeposit.data.attributes.comment"></v-textarea>
      </v-col>
      <v-alert class="mb-3" type="warning" :value="true" v-if="oneDeposit.data.attributes.used_in_problem_delivery">
        Usado para desconto em problemas com entrega!
      </v-alert>

      <v-col cols='5' v-if="can_show_actions && !oneDeposit.data.attributes.deposited">
        <v-btn text color="red darken-1" class="white--text" @click="editDeposit = true" rounded :disabled="!canEdit">
          <v-icon left>create</v-icon>
          editar
        </v-btn>
      </v-col>
      <v-col cols='5' v-if="can_show_actions && oneDeposit.data.attributes.deposited && !oneDeposit.data.attributes.concluded_at">
        <v-btn text color="red darken-1" class="white--text" @click="editDeposit = true" rounded :disabled="!canEdit">
          <v-icon left>create</v-icon>
          editar
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-expansion-panels v-if="oneDeposit != null" popout multiple flat active-class="elevation-4">
      <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
        <v-expansion-panel-header class="red--text font-weight-bold">Informações do Depósito</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container grid-list-xl>
            <!-- <v-text-field readonly label="Num. Depósito" :value="oneDeposit.data.attributes.number"></v-text-field> -->
            <v-text-field readonly label="Total" prefix="R$ " v-money="money" :value="oneDeposit.data.attributes.value"></v-text-field>
            <!-- <v-text-field readonly label="Em Dinheiro"  prefix="R$ " v-money="money" :value="oneDeposit.data.attributes.cash_value" v-if="oneDeposit.data.attributes.cash_value"></v-text-field> -->
            <!-- <v-text-field readonly label="Em Cheque"    prefix="R$ " v-money="money" :value="oneDeposit.data.attributes.check_value" v-if="oneDeposit.data.attributes.check_value"></v-text-field> -->
            <v-text-field readonly label="A vista" prefix="R$ " v-money="money" :value="oneDeposit.data.attributes.entrance_value"
              v-if="oneDeposit.data.attributes.entrance_value"
            ></v-text-field>
            <v-text-field readonly label="1 dia bloqueado" prefix="R$ " v-money="money" :value="oneDeposit.data.attributes.one_day_value"
              v-if="oneDeposit.data.attributes.one_day_value"
            ></v-text-field>
            <v-text-field readonly label="2 dias bloqueados" prefix="R$ " v-money="money" :value="oneDeposit.data.attributes.two_days_value"
              v-if="oneDeposit.data.attributes.two_days_value"
            ></v-text-field>
          </v-container>

        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple v-if="oneDeposit.data.attributes.returned">
        <v-expansion-panel-header class="red--text font-weight-bold">Informações do retorno</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container grid-list-xl>
            <v-text-field readonly label="Razão do problema"
              :value="oneDeposit.data.attributes.returned_due"></v-text-field>
            <v-text-field readonly label="Valor" prefix="R$ " v-money="money"
              :value="oneDeposit.data.attributes.returned_value"></v-text-field>
          </v-container>

        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
        <v-expansion-panel-header class="red--text font-weight-bold">Anexos</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container grid-list-xl>
            <div class="mt-2 mb-2">
              <input type="file" accept="application/pdf, image/*" style="display: none" id="file" ref="file"
                @change="handleFile()">
            </div>
            <v-btn :disabled="!isManager && !isFinancial && !isDirector && !isAnalyst" rounded color="info"
              class="font-weight-bold" @click="$refs.file.click()"
              v-if="can_show_actions && oneDeposit.data.attributes.status_id != concluded_id && !oneDeposit.data.attributes.returned">
              <v-icon left style="font-size: 22px">fa-camera-retro</v-icon> {{
                oneDeposit.data.attributes.document ?
                  'Alterar' : 'Adicionar'
              }} anexo
            </v-btn>
            <template v-if="oneDeposit.data.attributes.document && !newAttachment">
              <iframe v-if="oneDeposit.data.attributes.document.data.attributes.kind.includes('pdf') && !isMobile"
                :src="oneDeposit.data.attributes.document.data.attributes.document" width="400" height="500"></iframe>
              <v-img v-if="oneDeposit.data.attributes.document.data.attributes.kind.includes('ima')"
                :src="oneDeposit.data.attributes.document.data.attributes.document" contain></v-img>
              <v-btn text small color="primary"
                @click="downloadDocument(oneDeposit.data.attributes.document.data.attributes.document)" rouded><v-icon
                  left small>fa-download</v-icon> Baixar Documento</v-btn>
            </template>
            <template v-if="can_show_actions && newAttachment">
              <v-btn rounded color="success" class="font-weight-bold" @click="updateDocuments()">
                <v-icon left style="font-size: 22px">fa-save</v-icon> Atualizar
              </v-btn>
              <iframe v-if="attachment_attributes.type.includes('pdf') && !isMobile" :src="newAttachment" width="400"
                height="500"></iframe>
              <v-img v-if="attachment_attributes.type.includes('ima')" :src="newAttachment" contain></v-img>
              <v-list>
                <!-- <v-list-item v-for="(f,id) in driver.cnhFile" :key="id"> -->
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ attachment_attributes.name }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn text icon @click="removeFile()" v-if="can_show_actions"> <v-icon small
                        color="red">fa-trash-alt</v-icon> </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </template>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-divider></v-divider>
    <v-divider></v-divider>

    <v-row justify="space-around" class="py-3" v-if="can_show_actions">
      <template>
        <v-col cols='6' v-if="!oneDeposit.data.attributes.deposited">
          <v-btn :disabled="!isFinancial && !isDirector && !isManager && !isAnalyst" rounded
            class="font-weight-bold" color="info" @click="confirm_deposit()"> <v-icon left
              style="font-size: 22px">fa-check</v-icon> Confirmar</v-btn>
        </v-col>
        <v-col cols='6' v-if="(!oneDeposit.data.attributes.concluded && !oneDeposit.data.attributes.concluded_at && !oneDeposit.data.attributes.returned_due)">
          <v-btn :disabled="!isFinancial && !isDirector" rounded class="font-weight-bold" color="error" @click="delete_deposit()"> <v-icon left style="font-size: 22px">fa-trash-alt</v-icon> Excluir</v-btn>
        </v-col>
      </template>
      <template v-if="oneDeposit.data.attributes.status_id == confirmed_id && oneDeposit.data.attributes.deposited && (!oneDeposit.data.attributes.concluded && !oneDeposit.data.attributes.concluded_at && !oneDeposit.data.attributes.returned_due)">
        <v-col cols='6' v-if="isDirector() || isAnalyst()">
          <v-btn rounded class="font-weight-bold" color="success"
            @click="conclude_deposit()"> <v-icon left style="font-size: 22px">fa-vote-yea</v-icon> Em conta</v-btn>
        </v-col>
        <v-col cols='6'>
          <v-btn :disabled="!isDirector && !isAnalyst" rounded class="font-weight-bold" color="error"
            @click="dialogReturn = true"> <v-icon left style="font-size: 22px">fa-exclamation-circle</v-icon>
            Problema</v-btn>
        </v-col>
      </template>
      <v-col cols='6' v-if="(!oneDeposit.data.attributes.concluded && !oneDeposit.data.attributes.concluded_at && !oneDeposit.data.attributes.returned_due)">
        <!-- <v-btn :disabled="!isFinancial && !isDirector && !isAnalyst" rounded class="font-weight-bold" color="error" @click="delete_deposit()"> 
          <v-icon left style="font-size: 22px">fa-trash-alt</v-icon>
          Excluir
        </v-btn> -->
      </v-col>
      <template v-if="oneDeposit.data.attributes.deposited && (oneDeposit.data.attributes.concluded_at || oneDeposit.data.attributes.returned_due)">
        <v-col cols='10'>
          <v-alert :type="oneDeposit.data.attributes.returned ? 'error' : 'success'" :value="true">
            <h3> {{ oneDeposit.data.attributes.returned ? 'Depósito extornado' : 'Depósito em conta' }} </h3>
          </v-alert>
        </v-col>
      </template>
    </v-row>




    <v-dialog v-model="editDeposit" persistent max-width="800px" v-if="editDeposit" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Editando depósito</h3>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols='10'>
              <v-autocomplete v-if="!oneDeposit.data.attributes.concluded_at"
                v-model="oneDeposit.data.attributes.new_client_id" :items="allClients" label="Cliente" item-value="id"
                :loading="!allClients" :readonly="!allClients" prepend-icon="mdi-star"
                :item-text="formatClientDisplayName" :rules="[rules.required]" lazy
              >
                <template v-slot:no-data>
                  <span> Cliente não cadastrado </span>
                </template>
                
                <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                <template v-slot:selection="data">
                  {{ formatClientDisplayName(data.item) }} <span v-if="data.item.attributes.fantasyName">({{ data.item.attributes.fantasyName }})</span>
                </template>
                <template v-slot:item="data">
                  <!-- <v-list-item avatar @click="handleClientSelect(data)" :class="data.value ? 'blue lighten-5' : ''"> -->
                    <v-list-item-content>
                      <v-list-item-title>
                        <span class="grey--text"> Fantasia: </span> 
                        <span :class="['font-weight-bold', data.value ? 'primary--text ' : '']">
                          {{ data.item.attributes.fantasyName }}
                        </span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Nome/Razão Social: 
                        <span :class="['font-weight-bold', data.value ? 'primary--text ' : '']">
                          {{ formatClientDisplayName(data.item) }}
                        </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  <!-- </v-list-item> -->
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols='5'>
              <v-select :items="company_banks" v-model="oneDeposit.data.attributes.new_deposit_bank" :rules="[rules.required]" label="Banco"></v-select>
            </v-col>
            <v-col cols='5'>
              <SelectCompany @newCompany="handleNewCompany" :company="oneDeposit.data.attributes.new_deposit_company"></SelectCompany>
            </v-col>
            <v-col cols='10' v-if="!oneDeposit.data.attributes.concluded_at">
              <v-row>
                <v-checkbox label="Alterar valores" v-model="oneDeposit.change_values" :value="true"></v-checkbox>
                <v-checkbox label="Alterar Data" v-model="oneDeposit.change_date" :value="true"></v-checkbox>
              </v-row>
            </v-col>
            <template v-if="!oneDeposit.data.attributes.concluded_at && oneDeposit.change_date">

              <v-col cols='8' class="my-2">
                <v-dialog ref="dialogDate" v-model="modalDate" :return-value.sync="date2start" persistent lazy
                  width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-on="on" v-model="oneDeposit.data.attributes.new_deposit_date"
                      label="Data do depósito" prepend-icon="event" readonly></v-text-field>
                  </template>
                  <v-date-picker v-model="date2start" color="blue-grey darken-4" locale="pt-br" scrollable>
                    <v-spacer></v-spacer>
                    <f-btn cancel @click="modalDate = false"></f-btn>
                    <f-btn save @click="$refs.dialogDate.save(date2start)"></f-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </template>
            <template v-if="!oneDeposit.data.attributes.concluded_at && oneDeposit.change_values">
              <v-col cols='8' class="my-2">
                <v-text-field :label="'A vista'" @input="calc_new_value()" persistent-hint
                  :hint="'Valor original: R$ ' + (Number(oneDeposit.data.attributes.entrance_value)).toFixed(2)"
                  prefix="R$ " v-money="money" v-model="oneDeposit.data.attributes.new_entrance_value"
                ></v-text-field>
              </v-col>
              <v-col cols='8' class="my-2">
                <v-text-field :label="'1 dia bloqueado'" @input="calc_new_value()" persistent-hint
                  :hint="'Valor original: R$ ' + (Number(oneDeposit.data.attributes.one_day_value)).toFixed(2)"
                  prefix="R$ " v-money="money" v-model="oneDeposit.data.attributes.new_one_day_value"
                ></v-text-field>
              </v-col>
              <v-col cols='8' class="my-2">
                <v-text-field :label="'2 dias bloqueados'" @input="calc_new_value()" persistent-hint
                  :hint="'Valor original: R$ ' + (Number(oneDeposit.data.attributes.two_days_value)).toFixed(2)"
                  prefix="R$ " v-money="money" v-model="oneDeposit.data.attributes.new_two_days_value"
                ></v-text-field>
              </v-col>
              <v-col cols='10'>
                <v-divider></v-divider>
              </v-col>
              <v-col cols='8' class="my-2">
                <v-text-field readonly label="Total" persistent-hint
                  :hint="'Valor original: R$ ' + (Number(oneDeposit.data.attributes.value)).toFixed(2)" prefix="R$ "
                  :value="oneDeposit.data.attributes.new_value"
                ></v-text-field>
              </v-col>
            </template>

          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <f-btn cancel @click="editDeposit = false"></f-btn>
          <f-btn save @click="submitEditDeposit()"
            :disabled="oneDeposit.change_values && oneDeposit.data.attributes.new_value == '0.00'"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>






    <v-dialog v-model="dialogReturn" scrollable persistent max-width="400px" transition="dialog-transition">
      <v-card>
        <!-- <v-container grid-list-lg> -->
        <v-card-title class="py-1">
          <div class="text-h6">Detalhe o motivo e valor do problema/retorno</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-1">
          <v-container fluid class="py-0 px-1">
            <v-form ref="returnForm" lazy-validation v-model="validReturn">
              <v-radio-group v-model="returned_due" mandatory column row>
                <v-radio label="Cheques com problema" value="checks"></v-radio>
                <!-- <v-radio label="Outro" value="other"></v-radio> -->
              </v-radio-group>
              <!-- <v-text-field label="Razão do problema" v-model="returned_due"></v-text-field> -->
              <template v-if="returned_due == 'checks'">
                <v-form ref="returnDeposit" lazy-validation>

                  <v-col cols='4'>
                    <v-text-field v-model.number="qtd_checks" :rules="[rules.required]" prepend-icon="mdi-search"
                      v-mask="'##'" label="Cheques"
                    ></v-text-field>
                  </v-col>
                  <div v-for="(ck, idx) in qtd_checks" :key="'dvCk' + idx">
                    <v-subheader class="font-weith-bold primary--text">Cheque {{ ck }}</v-subheader>
                    <v-text-field v-model="returned_checks[idx].number" prepend-icon="mdi-barcode" v-mask="'######'"
                      :rules="[rules.ck_number]" label="Número do cheque"
                    ></v-text-field>
                    <v-text-field v-model="returned_checks[idx].motive" v-mask="'##'" type='number'
                      prepend-icon="mdi-help" :rules="[rules.required]" label="Motivo"
                    ></v-text-field>
                    <v-text-field v-model="returned_checks[idx].value_aux" prepend-icon="mdiCash"
                      :rules="[rules.notZero]" label="Valor R$" v-money="money"
                    ></v-text-field>
                    <v-divider></v-divider>
                  </div>
                </v-form>
              </template>
              <template v-if="returned_due == 'other'">
                <v-text-field label="Razão do problema" v-model="returned_comment" :rules="[rules.required]"></v-text-field>
                <!-- <v-text-field ref="value_return" label="Valor (R$)" v-money="money" v-model="returned_value" :rules="[rules.required]"></v-text-field> -->
              </template>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row justify="space-around">
            <v-col cols='6'>
              <v-btn rounded class="font-weight-bold" color="grey" dark @click="dialogReturn = false"> 
                <v-icon left style="font-size: 22px">fa-ban</v-icon> 
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols='6'>
              <v-btn rounded class="font-weight-bold" color="error" @click="return_deposit()"
                :disabled="!returned_due && qtd_checks < 1 /*|| returned_value == '0.00'*/"
              >
                <v-icon left style="font-size: 22px">fa-exclamation-circle</v-icon> 
                Relatar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <!-- </v-container> -->
      </v-card>
    </v-dialog>

    <v-dialog v-model="loading" persistent :overlay="false" max-width="500px" transition="dialog-transition">
      <v-card color="red darken-1" dark v-if="loading">
        <v-card-text>
          <v-col cols='12'>
            Salvando...
          </v-col>
          <v-col cols='12' class="mt-2">
            <v-progress-circular :size="70" :width="7" color="white" indeterminate></v-progress-circular>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import { mapActions, mapState } from 'vuex';
import { VMoney } from 'v-money'
import clientDisplay from '@/mixins/clientDisplay'


export default {
  name:"DepositProfile",
  components:{
    SelectCompany: () => import("@/_backoffice/_registrations/components/shared/SelectCompany.vue"),
  },
  directives: { money: VMoney },
  mixins: [clientDisplay],
  props: {
    can_show_actions: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },

      //files
      newAttachment: '',
      attachment_attributes: {},

      //returning
      dialogReturn: false,
      returned_due: 'checks',
      returned_value: null,
      returned_comment: null,
      qtd_checks: 0,
      validReturn: true,
      returned_checks: [],

      //saving
      loading: false,

      //to edit
      editDeposit: false,
      modalDate: false,
      date2start: null,
      company_banks: ['Itaú', 'Sicoob', 'Caixa', 'Banco do Brasil'],

      rules: {
        required: v => !!v || 'Campo é necessário',
        ck_number: v => !!v && v.length == 6 || 'Deve ter 6 dígitos. Ex: 000123',
        motive: v => !!v && (v >= 10 && v <= 99) || 'Deve ser entre 10 e 99',
        notZero: v => v != '0.00' || 'Não pode ser zero',
      },

    }
  },
  methods: {
    handleNewCompany(new_company){
      this.oneDeposit.data.attributes.new_deposit_company = new_company
    },
    downloadDocument(url) {
      window.open(url, '_blank')
    },
    formatDate(d) {
      if (!d) return null

      const [year, month, day] = d.split('-')
      return `${day}/${month}/${year}`
    },
    calc_new_value() {
      let { new_entrance_value, new_one_day_value, new_two_days_value, new_value } = this.oneDeposit.data.attributes
      new_value = Number(new_entrance_value.replace(/,/g, '')) + Number(new_one_day_value.replace(/,/g, '')) + Number(new_two_days_value.replace(/,/g, ''))
      // console.log(new_value);

      this.oneDeposit.data.attributes.new_value = new_value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    submitEditDeposit() {
      let confirmed
      if (this.oneDeposit.change_values) {
        confirmed = confirm('Certeza em alterar os valores do depósito?')
      } else {
        confirmed = true
      }
      if (confirmed) {
        // console.log('confirmed');

        // this.loading = true
        const { new_client_id, new_deposit_date, new_deposit_bank, new_deposit_company, id, new_entrance_value, new_one_day_value, new_two_days_value, new_value } = this.oneDeposit.data.attributes
        let obj_deposit = {
          id,
          deposit_bank: new_deposit_bank,
          deposit_company: new_deposit_company,
          deposit_date: new_deposit_date,
          client_id: new_client_id || this.oneDeposit.data.attributes.client_id
        }
        if (this.oneDeposit.change_values) {
          obj_deposit.entrance_value = new_entrance_value.replace(/,/g, '')
          obj_deposit.one_day_value = new_one_day_value.replace(/,/g, '')
          obj_deposit.two_days_value = new_two_days_value.replace(/,/g, '')
          obj_deposit.value = new_value.replace(/,/g, '')
        }
        // console.log({ obj_deposit });
        this.loading = true
        this.updateDeposit({
          financial: obj_deposit
        })
      }
    },
    delete_deposit() {
      let confirmed
      confirmed = confirm('Essa ação não poderá ser revertida! \nVocê realmente deseja excluir definitivamente o depósito?')

      if (confirmed) {
        this.loading = true
        this.deleteDeposit({
          financial: this.oneDeposit
        }).then(() => {
          setTimeout(() => {
            this.loading = false
            this.snackControl('success', 'Depósito deletado')
          }, 1500);
          setTimeout(() => {
            this.dialogReturn = false
            this.editDeposit = false

            this.removeFile()
            setTimeout(() => {
              this.$emit('done')
            }, 1000);
          }, 2000);
        })
      }
    },
    updateDocuments() {
      var { id, concluded_at, concluded_by_id, returned, status_id, attachment_attributes, document } = this.oneDeposit.data.attributes

      if (document) attachment_attributes.id = document.data.id

      var obj_deposit = {
        id,
        // concluded_at,
        // concluded_by_id,
        // returned,
        // status_id,
        attachment_attributes
      }

      this.loading = true

      this.updateDeposit({
        financial: obj_deposit
      })
    },
    confirm_deposit() {
      var now = new Date().toISOString()
      var { id, confirmed_at, confirmed_by_id, deposited, deposited_at, status_id, attachment_attributes } = this.oneDeposit.data.attributes
      confirmed_at = now.substring(0, 10) + ' ' + now.substring(11, 19)
      confirmed_by_id = this.profile.included[0].id
      deposited = true
      deposited_at = confirmed_at
      status_id = this.confirmed_id

      var obj_deposit = {
        id,
        confirmed_at,
        confirmed_by_id,
        deposited,
        deposited_at,
        status_id,
        attachment_attributes
      }

      this.loading = true

      this.updateDeposit({
        financial: obj_deposit
      })

    },
    conclude_deposit() {
      var now = new Date().toISOString()
      var { id, concluded_at, concluded_by_id, returned, status_id, attachment_attributes } = this.oneDeposit.data.attributes
      concluded_at = now.substring(0, 10) + ' ' + now.substring(11, 19)
      concluded_by_id = this.profile.included[0].id
      returned = false
      status_id = this.concluded_id

      var obj_deposit = {
        id,
        concluded_at,
        concluded_by_id,
        returned,
        status_id,
        attachment_attributes
      }

      this.loading = true

      this.updateDeposit({
        financial: obj_deposit
      })
    },
    return_deposit() {
      if (this.$refs.returnDeposit.validate()) {
        var now = new Date().toISOString()
        var { id, returned, returned_value, returned_due, attachment_attributes } = this.oneDeposit.data.attributes
        let returned_checks_attributes = []
        if (this.returned_due == 'other') {
          if (this.returned_value) {
            returned_value = this.returned_value.replace(/,/g, '')
          } else {
            returned_value = this.oneDeposit.data.attributes.value
          }
          returned_due = this.returned_comment

        } else if (this.returned_due == 'checks') {
          returned_due = 'Cheques voltaram'
          this.returned_checks.forEach(ck => {
            ck.value = Number(ck.value_aux.replace(/,/g, ''))
            ck.returned_by = this.profile.data.attributes.name
          });
          returned_checks_attributes = this.returned_checks
          returned_value = this.returned_checks.map(obj => obj.value).reduce((a, b) => { return a + b }, 0)
        }
        returned = true

        var obj_deposit = {
          id,
          returned,
          returned_value,
          returned_due,
          attachment_attributes,

          returned_checks_attributes,
        }

        this.loading = true

        this.updateDeposit({
          financial: obj_deposit
        })
      }
    },
    handleFile() {
      var uploadedFiles = this.$refs.file.files;
      //for( var i = 0; i < uploadedFiles.length; i++ ){
      // this.driver.cnhFile.push(uploadedFiles[i]);
      //}
      this.attachment_attributes = uploadedFiles[0];
      var fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.newAttachment = fileReader.result
        this.oneDeposit.data.attributes.attachment_attributes = {
          url_document: fileReader.result,
          name: this.attachment_attributes.name,
          kind: this.attachment_attributes.type,
          id: this.oneDeposit.data.attributes.document ? this.oneDeposit.data.attributes.document.data.id : null,
        }
        // console.log(this.oneDeposit.data.attributes.attachment_attributes);
      })
      // fileReader.readAsDataURL(this.driver.cnhFile[0])
      fileReader.readAsDataURL(this.attachment_attributes)
    },
    removeFile(i) {
      //this.driver.cnhFile.splice(i,1)
      this.oneDeposit.data.attributes.attachment_attributes = null
      this.attachment_attributes = null
      this.newAttachment = ''
    },
    snackControl(type, msg) {
      this.addNotification({type, msg})
    },
    ...mapActions({
      
      showFinancial: 'Financial/show',
      cleanVrtTrans: 'Financial/cleanVrtTrans',

      getDeposits: 'Financial/indexDeposit',

      updateDeposit: 'Financial/updateDeposit',
      deleteDeposit: 'Financial/deleteDeposit',

      getClients: 'Client/index',
    })
  },
  computed: {
    payed_id() {
      var payed = this.allStatuses.map(status => status.attributes.title).indexOf('Payed')
      // console.log(payed);
      payed = this.allStatuses[payed].attributes

      return 1 //payed.id
    },
    confirmed_id() {
      var confirmed = this.allStatuses.map(status => status.attributes.title).indexOf('Confirmed')
      // console.log(confirmed);
      confirmed = this.allStatuses[confirmed].attributes

      return confirmed.id
    },
    concluded_id() {
      var concluded = this.allStatuses.map(status => status.attributes.title).indexOf('Concluded')
      // console.log(concluded);
      concluded = this.allStatuses[concluded].attributes

      return concluded.id
    },
    isMobile() {
      // console.log(document.body.clientWidth);
      if (document.body.clientWidth < 700 && this.file.size)
        return true
      else
        return false
    },
    canEdit() {
      return this.isManager || this.isFinancial || this.isDirector || this.isAnalyst
    },
    ...mapState({
      profile: state => state.User.oneUser,
      allClients: state => state.Client.allClients,

      allDeposits: state => state.Financial.allDeposits,
      oneDeposit: state => state.Financial.oneDeposit,

      allStatuses: state => state.Status.allStatuses,

      update_was_good: state => state.Financial.update_was_good,
      update_message: state => state.Financial.update_message,

    })
  },
  watch: {
    editDeposit(nv, ov) {
      if (nv) {
        if (!this.allClients && !this.oneDeposit.data.attributes.concluded_at) {
          this.getClients()
        }
      } else if (nv == false) {

      }
    },
    qtd_checks(nv, ov) {
      if (nv > ov) {
        for (let index = 0; index < (nv - ov); index++) {
          this.returned_checks.push({})
        }
      } else if (nv < ov) {
        for (let index = 0; index < (ov - nv); index++) {
          this.returned_checks.pop()
        }
      }
    },
    update_was_good(nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.loading = false
        }, 1500);
        setTimeout(() => {
          this.snackControl('success', 'Depósito atualizado')
          this.dialogReturn = false
          this.editDeposit = false
          // this.getDeposits()

          this.showFinancial({ kind: 'deposits', id: this.oneDeposit.data.id })
          this.removeFile()
          if (this.dialogReturn) {
            this.dialogReturn = false
          } else if (!this.dialogReturn) {
          }
        }, 2000);
      } else if (nv == false) {
        setTimeout(() => {
          this.loading = false
        }, 1500);
        setTimeout(() => {
          this.snackControl('error', 'Erro: ' + this.update_message)
        }, 2000);
      }
    },
    dialogReturn(nv, ov) {
      if (nv == false) {
        this.returned_due = 'checks'
        this.$refs.value_return.$el.getElementsByTagName('input')[0].value = 0
        this.returned_value = '0.00'
      }
    },
    date2start(nv, ov) {
      if (nv) {
        this.oneDeposit.data.attributes.new_deposit_date = this.formatDate(this.date2start) // (new Date(nv)).toLocaleDateString('pt-BR') // 
      }
    },
  },
}
</script>
